import { ReactNode } from "react";
import { PageTitle } from ".";

interface SummaryInfoProps {
  title: string;
  children: ReactNode;
  className?: string;
}

export default function SummaryInfo({
  title,
  children,
  className = "",
}: SummaryInfoProps) {
  return (
    <div className={`mb-6 flex flex-col gap-y-4 ${className}`}>
      <PageTitle size="lg">{title}</PageTitle>
      <div className="grid grid-cols-[max-content_1fr] gap-x-12 gap-y-4">
        {children}
      </div>
    </div>
  );
}
